import React, { useMemo } from 'react'

export default function TablePCFOriginal({ pcf }) {
    const total_ori_pcf = useMemo(() => {
        let total = 0;
        const objSubjectUniq = pcf.reduce((accumulator, currentValue) => {
            if (currentValue && currentValue.hasOwnProperty('not_billed') && currentValue.not_billed === 0) {
                const { course_id, credit } = currentValue;
                if (!accumulator.hasOwnProperty(course_id)) {
                    accumulator[course_id] = credit;
                } else if (accumulator[course_id] !== credit) {
                    accumulator[course_id] += credit;
                }
            }
            return accumulator;
        }, {});

        console.log(pcf);
        console.log(objSubjectUniq);

        if (objSubjectUniq) {
            Object.keys(objSubjectUniq).map((k) => {
                total = total + objSubjectUniq[k];
            });
        }
        return total;
    }, [pcf])
    // var objSubjectUniq = pcf.reduce((accumulator, currentValue) => {
    //     if (currentValue.course_type !== "asc.course.type.optional") {
    //         const { course_id, credit } = currentValue;
    //         if (!accumulator.hasOwnProperty(course_id)) {
    //             accumulator[course_id] = credit;
    //         } else if (accumulator[course_id] !== credit) {
    //             accumulator[course_id] += credit;
    //         }
    //     }
    //     return accumulator;
    // }, {});
    // const objSubjectUniq = pcf.reduce((accumulator, currentValue) => {
    //     if (currentValue.detail && currentValue.detail.hasOwnProperty('not_billed') && currentValue.detail.not_billed === 0) {
    //         const { course_id, detail: { course_credit } } = currentValue;
    //         if (!accumulator.hasOwnProperty(course_id)) {
    //             accumulator[course_id] = course_credit;
    //         } else if (accumulator[course_id] !== course_credit) {
    //             accumulator[course_id] += course_credit;
    //         }
    //     }
    //     return accumulator;
    // }, {});
    // var tsks = 0;
    // if (objSubjectUniq) {
    //     Object.keys(objSubjectUniq).map((k) => {
    //         tsks = tsks + objSubjectUniq[k];
    //     });
    // }
    return (
        <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                    <tr className="font-weight-boldest h-65px" style={{ backgroundColor: "#474bcf" }}>
                        <th className="align-middle font-size-h4 text-white border-0" width={"5%"}>No</th>
                        <th className="align-middle font-size-h4 text-white border-0">Course</th>
                        <th className="align-middle font-size-h4 text-white border-0">Type/Credit</th>
                        <th className="align-middle font-size-h4 text-white border-0">Section ID</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.values(pcf).length > 0 ? (
                        pcf.map((v, index) => {
                            var c_type = "";
                            if (v.course_type) {
                                let typeArr = v.course_type.split(".");
                                c_type = typeArr[typeArr.length - 1];
                            }
                            return (
                                <tr key={index} className="font-size-lg font-weight-bolder h-65px">
                                    <td>{index + 1}</td>
                                    <td>
                                        <span className="d-block font-weight-bolder">
                                            {v?.coursetitle}
                                        </span>
                                        <span className="text-muted font-weight-bolder">
                                            {v?.code}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="d-block text-capitalize font-weight-bolder">
                                            Credit {v?.credit} SKS
                                        </span>
                                        <span className="text-muted text-capitalize font-weight-bolder">
                                            {c_type}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="font-weight-bolder">
                                            {v?.section_id}
                                        </span>
                                    </td>
                                </tr>
                            )
                        }
                        )
                    ) : (
                        <tr>
                            <td colSpan={5}>No record found</td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={2} className="font-weight-bolder text-right">Total Credit:</td>
                        <td className="font-weight-bolder">{total_ori_pcf} SKS</td>
                        <td colSpan={2}></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}
